import React from 'react';
import PropTypes from 'prop-types';
import { OnlineWrapper, OnlineLabel, OnlineTitle } from './styles';

export default function Online(props) {
	return <OnlineWrapper className={props.className}>
		<a href={props.link}>
			<OnlineLabel>Online</OnlineLabel>
			<OnlineTitle>{props.title}</OnlineTitle>
		</a>
	</OnlineWrapper>
}

Online.propTypes = {
	link: PropTypes.string.isRequired,
	title: PropTypes.string.isRequired
};
